module.exports = __webpack_public_path__ + "static/img/shoujia.5cc561c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shoujia.png
// module id = wR/U
// module chunks = 68